import { Box, Typography, makeStyles } from '@material-ui/core'
import React from 'react'

const useStyles = makeStyles((theme) => ({
  wrapper: {
    position: 'relative',
    backgroundColor: 'transparent',
  },
  text: {
    '-webkit-text-stroke': ({ color }) =>
      `1px ${color || theme.palette.secondary.main}`,
    color: 'transparent',
    textStroke: ({ color }) => `1px ${color || theme.palette.secondary.main}`,
    zIndex: theme.zIndex.xRayWrapper,
  },
  textXRay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    textStroke: 'unset',
    textShadow: 'unset',
    filter: 'unset',
    color: ({ color }) => color || theme.palette.secondary.main,
    zIndex: theme.zIndex.xRayText,
    textAlign: 'inherit',
  },
}))
const XRayText = (
  { color, content, wrapperClass, textClass, ...props },
  ref,
) => {
  const classes = useStyles({ color })
  return (
    <Box className={[wrapperClass, classes.wrapper].join(' ')}>
      <Typography
        ref={ref}
        {...props}
        className={[textClass, classes.text].join(' ')}
      >
        {content}
      </Typography>
      <Typography
        {...props}
        className={[textClass, classes.textXRay].join(' ')}
      >
        {content}
      </Typography>
    </Box>
  )
}
export default React.forwardRef(XRayText)
